import React from 'react';

import { Button } from '@copilot/ui';
import { reportError } from '../../services/errorTracking';

/**
 * Catches unexpected render/lifecycle errors anywhere below it in the
 * tree and shows a friendly fallback instead of a blank/broken screen.
 * Must be a class component - getDerivedStateFromError/componentDidCatch
 * have no hook equivalent.
 *
 * Deliberately does not expose the error message or stack trace to the
 * user - only reportError (services/errorTracking.js) sees it, which
 * itself only logs in development/test and stays silent in production.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // The component stack is component names only (no props or text).
    reportError('react_error_boundary', error, {
      componentStack: info && info.componentStack ? String(info.componentStack) : undefined,
    });
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary-fallback">
          <div className="error-boundary-card">
            <div className="empty-state-title">Something went wrong.</div>
            <p>Please refresh the page and try again.</p>
            <Button onClick={this.handleReload}>Reload</Button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
